import { useTranslation } from "react-i18next";

import { Illustration } from "@atoms";
import { Button } from "@molecules";

type HaNResultListErrorProps = {
  text: string;
  onRetry: () => void;
};

export const HaNResultListError = ({ text, onRetry }: HaNResultListErrorProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="flex flex-auto flex-col items-center justify-center gap-4 p-8">
      <Illustration illustration="error" />
      <p className="text-center">{text}</p>
      <Button
        size="small"
        button="secondary"
        onClick={onRetry}>
        {t("translation:Retry")}
      </Button>
    </div>
  );
};
